import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=11b0bcd5&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b0bcd5')) {
      api.createRecord('11b0bcd5', component.options)
    } else {
      api.reload('11b0bcd5', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=11b0bcd5&", function () {
      api.rerender('11b0bcd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/Logo.vue"
export default component.exports